<template>
    <div ref="recoveryCodesBlock" class="card mb-3">
        <div class="card-header">
            <h5 class="card-title mb-0">Recovery Codes</h5>
        </div>
        <div class="card-body">
            <div v-if="recoveryCodesMessage">
                <div class="alert alert-info alert-dismissible fade show" role="alert">
                    <span v-html="recoveryCodesMessage"></span>
                    <button type="button" class="btn-close" @click="(event) => recoveryCodesMessage = ''" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            </div>

            <div class="mb-3">
                <button v-if="user && user.has_recovery_codes" type="button" class="btn btn-outline-dark rounded-pill py-2 px-3 me-2 mt-1" @click="viewRecoveryCodes" v-ripple>View Recovery Codes</button>
	            <button type="button" class="btn btn-dark rounded-pill py-2 px-3 me-2 mt-1" @click="regenerateRecoveryCodes" v-ripple>{{ user && user.has_recovery_codes ? 'Regenerate Recovery Codes' : 'Generate Recovery Codes' }}</button>
	            <button v-if="user && user.has_recovery_codes" type="button" class="btn btn-outline-danger rounded-pill py-2 px-3 mt-1" @click="deleteRecoveryCodes" v-ripple>Delete Recovery Codes</button>
            </div>

	        <div>
		        <div class="alert fade show" role="alert">
			        <div class="mb-2">
				        <span class="fw-medium">Instructions related to Recovery Codes:</span>
			        </div>
			        <div>
				        <ul class="text-muted">
					        <li>You can access your "Recovery Codes" by clicking the button "View Recovery Codes".</li>
					        <li>Save the recovery code somewhere safe, you will need them in case you lost access to the device used to setup 2FA
						        or email account used for 2FA.</li>
					        <li>Recovery code once used cannot be used again. One recovery code can only be used once.</li>
					        <li>You can generate new set of recovery code whenever you want by clicking the "Generate New Recovery Codes" button.</li>
				        </ul>
			        </div>
		        </div>
	        </div>

        </div>
    </div>
	<AuthenticatedActionModal :action="authAction" :consider-trusted-device="considerTrustedDevice" :can-switch-two-factor-method="switchTwoFactorMethods" :can-use-recovery-codes="useRecoveryCodes" :reload-user="reloadUser" v-if="showActionModal && authAction" @close-modal="closeAuthActionModal"></AuthenticatedActionModal>

</template>

<script setup>
import {watch, ref} from "vue";
import {useAuthStore} from "@/stores/auth-store.js";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import AuthenticatedActionModal from "@/components/GenericModalAndViews/AuthenticatedActionModal.vue";

const auth = useAuthStore();
const helper = useAppHelpers();
const recoveryCodesBlock = ref(null);

const showActionModal = ref(false);
const considerTrustedDevice = ref(true);
const switchTwoFactorMethods = ref(false);
const useRecoveryCodes = ref(false);
const reloadUser = ref(true);
const authAction = ref('');

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const closeAuthActionModal = async () => {
	authAction.value = '';
	showActionModal.value = false;
	considerTrustedDevice.value = true;
	switchTwoFactorMethods.value = false;
	reloadUser.value = true;
	useRecoveryCodes.value = false;
}

const viewRecoveryCodes = () => {
	authAction.value = 'two_factor_recovery_code';
	considerTrustedDevice.value = true;
	switchTwoFactorMethods.value = false;
	useRecoveryCodes.value = false;
	reloadUser.value = false;
	showActionModal.value = true;
}

const regenerateRecoveryCodes = () => {
	authAction.value = 'two_factor_regenerate_recovery_code';
	considerTrustedDevice.value = false;
	switchTwoFactorMethods.value = false;
	useRecoveryCodes.value = false;
	showActionModal.value = true;
}

const deleteRecoveryCodes = () => {
	authAction.value = 'two_factor_delete_recovery_code';
	considerTrustedDevice.value = false;
	switchTwoFactorMethods.value = false;
	useRecoveryCodes.value = false;
	showActionModal.value = true;
}

const recoveryCodesMessage = ref('');

</script>

<style lang="scss" scoped>

</style>
